import { createFileRoute } from '@tanstack/react-router'
import { SerialDetailPage } from '../../../features/inventory/serials/serial-pages'

export const Route = createFileRoute('/_app/serials/$serialId')({
  staticData: { crumb: 'serial' },
  component: SerialDetailPage,
})
